import { Skeleton, Stack } from '@mantine/core';

import { ErrorAlert } from '~/domains/common/components/Alerts/Alerts';
import dt from '~/testing';

import { DepositForm } from './DepositForm';
import DepositCompleted from './DepositCompleted';
import useDepositView from './useDepositView';

type DepositViewProps = {
  contestIdForPostDeposit?: string;
  fallbackUrl?: string;
  isRedirectOnInvalidAccess?: boolean;
  selectedBonusId?: string;
  redirectTo?: string;
};

function DepositView({
  contestIdForPostDeposit,
  fallbackUrl,
  isRedirectOnInvalidAccess,
  selectedBonusId,
  redirectTo: redirectToFromProps,
}: DepositViewProps) {
  const {
    completedDepositAmount,
    completedDepositResponse,
    handleOnContinue,
    handleSetCompletedDepositAmount,
    isAccessible,
    isDepositEnabled,
    isDepositMatchBonusEnabled,
    isProtectionLoading,
    onDetailsClick,
    redirectTo,
    selectedBonus,
    t,
  } = useDepositView({
    contestIdForPostDeposit,
    isRedirectOnInvalidAccess,
    selectedBonusId,
    redirectToFromProps,
  });

  if (completedDepositAmount !== null) {
    return (
      <Stack data-test-id={dt.payments.deposits.depositView} maw={450} mx="auto" pos="relative">
        <DepositCompleted
          depositAmount={completedDepositAmount}
          depositResponse={completedDepositResponse}
          onClose={handleOnContinue}
          contestId={contestIdForPostDeposit}
          redirectTo={redirectTo}
        />
      </Stack>
    );
  }

  return (
    <Stack data-test-id={dt.payments.deposits.depositView} maw={450} mx="auto" pos="relative">
      {(() => {
        if (!isDepositEnabled) {
          return <ErrorAlert>{t('deposits.errors.blockedByFeatureFlag')}</ErrorAlert>;
        }

        if (isProtectionLoading || !isAccessible) {
          return (
            <Stack spacing="md">
              <Skeleton height={80} animate />
              <Skeleton height={100} animate />
              <Skeleton height={170} animate />
              <Skeleton height={340} animate />
            </Stack>
          );
        }

        return (
          <DepositForm
            contestIdForPostDeposit={contestIdForPostDeposit}
            setCompletedDepositAmount={handleSetCompletedDepositAmount}
            fallbackUrl={fallbackUrl}
            depositBonus={isDepositMatchBonusEnabled && selectedBonus ? selectedBonus : undefined}
            onViewDepositBonusDetails={onDetailsClick}
            redirectTo={redirectTo}
          />
        );
      })()}
    </Stack>
  );
}

export { DepositView };
